import { observer } from "mobx-react"
import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
import { Divider, Dropdown } from "semantic-ui-react"
import categoryStore from "stores/categoryStore"

@observer
export default class CategoryDropdown extends Component {

  render() {
    const {fluid = true} = this.props
    const { categories } = categoryStore
    return <Dropdown fluid={fluid} style={{ width: "150px" }}  item text={<span className="pre ">{translate("Alle Kategorien")}</span>}>
      <Dropdown.Menu>
        <Dropdown.Item text={<span className="pre ">{translate("Alle Kategorien")}</span>} as={Link} to={"/collection/"}/>
        <Divider/>
        {categories.map( category => <Dropdown.Item key={category.map_id} text={category.title} as={Link} to={`/collection/${category.map_id}`}/> )}
      </Dropdown.Menu>
    </Dropdown>
  }
}


// WEBPACK FOOTER //
// ./src/components/Category/CategoryDropdown.js